module.exports = __webpack_public_path__ + "img/corneal-infiltrates-4.a76e9bc7.jpg";